import { useLocation } from 'react-router-dom'

import { AI_AUTOMATION_ROUTE_ITEMS, AiAutomationRoute } from '../routeItems'

export const useAiAutomationCurrentRoute = (): AiAutomationRoute | null => {
  const { pathname } = useLocation()

  const currentRoute = AI_AUTOMATION_ROUTE_ITEMS.find((item) =>
    pathname.includes(`/ai/${item.path}`),
  )

  return currentRoute?.path ?? null
}
